export default "/kiban/_next/static/images/size-e9097b5eeafdefe5f2469a8687e55429.png";